import { useField, FieldHookConfig } from 'formik';
import tw from 'tailwind-styled-components';

interface BaseSelectProps {
  hasError: boolean;
}

const BaseSelect = tw.select<BaseSelectProps>`
mt-1 block w-full  py-2 pl-3 pr-10 lg:text-sm md:text-xs text-xs focus:outline-none
${(props) =>
  !props.hasError &&
  !props.value &&
  'border-primary-300 focus:border-primary-500 focus:ring-primary-500'} 
${(props) =>
  !props.hasError &&
  !!props.value &&
  'border-primary-300 focus:border-primary-500 focus:ring-primary-500 bg-green-50'} 
${(props) =>
  props.hasError &&
  !props.value &&
  'border-green-300 focus:border-green-500 focus:ring-green-500'} 
${(props) =>
  props.hasError &&
  !!props.value &&
  'border-red-300 focus:border-red-500 focus:ring-red-500 bg-red-100'} 
`;

interface SelectOptions {
  selected?: boolean;
  value: string;
  text: string | number;
  id?: number;
}

type Props = {
  label?: string;
  selection: SelectOptions[];
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
} & FieldHookConfig<string>;

export const FormikSelect: React.FC<Props> = ({
  label,
  selection,
  onChange,
  ...props
}) => {
  const [field, meta, helpers] = useField(props);
  return (
    <div>
      <label className="block lg:text-sm md:text-sm text-xs font-medium text-green-700">
        {label}
      </label>
      <BaseSelect
        {...field}
        hasError={!!meta.error}
        onChange={(e) => {
          helpers.setValue(e.target.value);
          if (onChange) {
            onChange(e);
          }
        }}
      >
        {selection.map((row, index) => (
          <option key={index} value={row.value}>
            {row.text}
          </option>
        ))}
      </BaseSelect>
      {meta.error ? (
        <div className="text-red-500 text-xs md:text-sm">{meta.error}</div>
      ) : null}
    </div>
  );
};
